import React from 'react';

const RefundTicket = () => {
  return (
      <div>
        
         <div className ="account-entries">
                <div className="entries-header">
                    <div>Show Entries 10</div>
            
                    <div className="entries-controls">
                    {/* Select Date Fields */}
                    <input type="date" placeholder="From Date" />
                    <input type="date" placeholder="To Date" />

                    {/* Search Text Field */}
                    <input type="text" placeholder="Search..." />

                    {/* Buttons */}
                    <button>Search</button>
                    <button>Download</button>
                </div>
                </div>
                <div>
                    <table>
                        <tr>
                            <th>#Ref no</th>
                            <th>Ticket ID</th>
                            <th>Entry Date</th>
                            <th>Detination</th>
                            <th>PNR</th>
                            <th>Travel Date</th>
                            <th>Time</th>
                            <th>Qty</th>
                            <th>XXLN</th>
                            <th>Refund Amt</th>
                            <th>Action</th>
                        </tr>
                        <tr>
                            <td> 1</td>
                            <td> 1</td>
                            <td> 1</td>
                            <td> 1</td>
                            <td> 1</td>
                            <td> 1</td>
                            <td> 1</td>
                            <td> 1</td>
                            <td> 1</td>
                            <td> 1</td>
                            
                        </tr>
                        <tr>
                            <td className= "entries-pagination"  colspan="11">1</td>
                            </tr>
                    </table>
                </div>
            </div>
      </div>
  )
}
export default RefundTicket